var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import getMediaField from "./media";

export default function getVideoField(props) {
    return getMediaField(_extends({}, props, { mediaType: "video" }));
}